import React from 'react';
import type { FaqItem } from '../data/faqData';

interface FaqAnswerProps {
  answer: FaqItem['answer'];
  /** Clase opcional para el contenedor de la respuesta con bloques. */
  className?: string;
}

/**
 * Renderiza la respuesta de una FAQ. Acepta un texto simple (string) o una
 * lista de bloques (parrafos y listas con vinetas) para respuestas complejas.
 */
const FaqAnswer: React.FC<FaqAnswerProps> = ({ answer, className }) => {
  if (typeof answer === 'string') {
    return <p>{answer}</p>;
  }

  return (
    <div className={className}>
      {answer.map((block, index) => {
        if (block.type === 'paragraph') {
          return <p key={index}>{block.text}</p>;
        }
        return (
          <ul key={index}>
            {block.items.map((item, itemIndex) => (
              <li key={itemIndex}>
                {item.label ? <strong>{item.label}</strong> : null}
                {item.label ? ' ' : null}
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noreferrer">
                    {item.text}
                  </a>
                ) : (
                  item.text
                )}
              </li>
            ))}
          </ul>
        );
      })}
    </div>
  );
};

export default FaqAnswer;
